import React, { useEffect, useState } from 'react';
import { Form, Select, InputNumber, Button, Input, Spin, message } from 'antd';
import { DatePicker } from 'antd';
import AppLayout from '../../components/AppLayout';
import { useNavigate } from 'react-router-dom';

const WorkOrderForm: React.FC = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const demoProducts = [
    { _id: '1', name: 'Product A' },
    { _id: '2', name: 'Product B' },
    { _id: '3', name: 'Product C' },
  ];

  const handleSubmit = async (values: any) => {
    console.log('Demo submit:', values);
    message.success('Demo: Work order saved');
    navigate(-1);
  };

  return (
    <Spin spinning={loading} size='large'>
      <AppLayout>
        <Form layout="vertical" onFinish={handleSubmit} form={form}>
          <h3>Create Work Order</h3>

          <Form.Item label="Work Order No">
            <Input value={`WOR-${Math.floor(Math.random() * 900 + 100)}`} readOnly />
          </Form.Item>

          <Form.Item name="product_id" label="Product" rules={[{ required: true }]}>
            <Select options={demoProducts.map((p: any) => ({ label: p.name, value: p._id }))} />
          </Form.Item>

          <Form.Item name="quantity" label="Quantity" rules={[{ required: true }]}>
            <InputNumber min={1} style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item name="timeline" label="Production Timeline">
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item name="stage" label="Production Stage">
            <Select
              placeholder="Select Stage"
              options={[
                { label: 'Cutting', value: 'Cutting' },
                { label: 'Assembly', value: 'Assembly' },
                { label: 'Packaging', value: 'Packaging' },
              ]}
            />
          </Form.Item>

          <Form.Item name="status" label="Status">
            <Select
              placeholder="Select Status"
              options={[
                { label: 'Pending', value: 'Pending' },
                { label: 'In Progress', value: 'In Progress' },
                { label: 'Completed', value: 'Completed' },
              ]}
            />
          </Form.Item>

          <Form.Item name="technician_id" label="Technician (Optional)">
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">Create Work Order</Button>
          </Form.Item>
        </Form>
      </AppLayout>
    </Spin>
  );
};

export default WorkOrderForm;
